<template>
    <v-row class="login-page">
        <v-col cols="12" lg="8" md="8" sm="12" xs="12" class="title">
            <div>
                <h1 class="header">Welcome,</h1>
            </div>
            <div class="header" style="margin-top: -25px">
                <h1>
                    {{ $page.props.auth.user.firstName }}
                </h1>
            </div>
            <v-col
                cols="12"
                lg="6"
                md="6"
                sm="12"
                xs="12"
                style="margin-top: -30px"
            >
                To begin navigating, click on the menu button in the top left
                corner of the screen or click on one of the icons in the top
                right corner of the screen.
            </v-col>
            <div>
                <PhoneListComponent />
                <v-expansion-panels
                    class="rounded-xl"
                    style="margin-top: 20px; width: 495px"
                >
                    <v-expansion-panel title="My Profile">
                        <v-expansion-panel-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="myEmail"
                                        label="Email"
                                        hide-details
                                        readonly
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="myDepartment"
                                        label="Department"
                                        hide-details
                                        readonly
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="myPrintId"
                                        label="Print ID#"
                                        hide-details
                                        readonly
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-text>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
        </v-col>

    </v-row>
</template>

<script>

import { defineAsyncComponent } from "vue";
const PhoneListComponent = defineAsyncComponent(() =>
    import("./User/PhoneListComponent.vue")
);

export default {
    components: {
        PhoneListComponent,
    },
    computed: {
        isSupervisor() {
            return this.$page.props.auth.user.supervisor;
        },
        myEmail() {
            return this.$page.props.auth.user.email;
        },
        myPrintId() {
            return this.$page.props.auth.user.printID;
        },
        myDepartment() {
            return this.$page.props.auth.user.departmentFK;
        },
    },
};
</script>
<style scoped>
.title {
    padding: 45px;
}

.header {
    font-size: 47px;
}

.login-page {
    background-image: url("/images/homePage.jpg");
    background-size: cover;
    background-position: center;
    height: 93vh;
}

@media (max-width: 1024px) {
    .login-page {
        background-image: none;
    }
}
</style>
